// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .etichetta {
  font-size: 1.2em;
}`, "",{"version":3,"sources":["webpack://./src/app/interventi/popover-data/popover-data.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR","sourcesContent":[":host {\r\n    .etichetta {\r\n        font-size: 1.2em;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
